import { InventoryDocumentKind, PurchaseDocumentKind, SaleDocumentKind } from '@skylab-shared/dataModel';
import { AppStates, State } from '@skylab-shared/scenes';

export class DocumentsRouting {
    public static getEditState(kind: SaleDocumentKind | PurchaseDocumentKind | InventoryDocumentKind): State {
        switch (kind) {
            case SaleDocumentKind.Invoice:
            case SaleDocumentKind.Receipt:
            case SaleDocumentKind.VatMarginInvoice:
                return AppStates.editDocumentSale;

            case SaleDocumentKind.AdvanceInvoice:
                return AppStates.editAdvanceInvoiceDocument;

            case SaleDocumentKind.AdvanceInvoiceAdjustment:
                return AppStates.editAdvanceInvoiceAdjustment;

            case SaleDocumentKind.InvoiceAdjustment:
            case SaleDocumentKind.ReceiptAdjustment:
            case SaleDocumentKind.VatMarginInvoiceAdjustment:
                return AppStates.editSaleDocumentAdjustment;

            case SaleDocumentKind.ProForma:
                return AppStates.editProFormaDocument;

            case PurchaseDocumentKind.Expense:
                return AppStates.editPurchaseExpense;

            case PurchaseDocumentKind.PurchaseInvoice:
                return AppStates.editPurchaseInvoice;

            case PurchaseDocumentKind.EPurchaseInvoice:
                return AppStates.editPurchaseEInvoice;

            case PurchaseDocumentKind.PurchaseInvoiceAdjustment:
                return AppStates.editPurchaseInvoiceAdjustment;

            case InventoryDocumentKind.GoodsIssue:
            case InventoryDocumentKind.InternalGoodsIssue:
                return AppStates.inventoryGoodsIssueEdit;

            case InventoryDocumentKind.GoodsReceipt:
            case InventoryDocumentKind.InternalGoodsReceipt:
                return AppStates.inventoryGoodsReceiptEdit;

            case InventoryDocumentKind.GoodsIssueAdjustment:
                return AppStates.inventoryGoodsIssueAdjustmentEdit;
            case InventoryDocumentKind.GoodsReceiptAdjustment:
                return AppStates.inventoryGoodsReceiptAdjustmentEdit;

            case InventoryDocumentKind.Stocktaking:
                return AppStates.inventoryStocktakingEdit;
        }
        throw new Error(`Unsupported document kind: ${kind}`);
    }
 
    public static getCreateState(kind: SaleDocumentKind | PurchaseDocumentKind | InventoryDocumentKind): State {
        switch (kind) {
            case SaleDocumentKind.Invoice:
            case SaleDocumentKind.Receipt:
            case SaleDocumentKind.VatMarginInvoice:
                return AppStates.newDocumentSale;
 
            case SaleDocumentKind.AdvanceInvoice:
                return AppStates.newAdvanceInvoiceDocument;
 
            case SaleDocumentKind.AdvanceInvoiceAdjustment:
                return AppStates.newAdvanceInvoiceAdjustment;
 
            case SaleDocumentKind.InvoiceAdjustment:
            case SaleDocumentKind.ReceiptAdjustment:
            case SaleDocumentKind.VatMarginInvoiceAdjustment:
                return AppStates.newSaleDocumentAdjustment;
 
            case SaleDocumentKind.ProForma:
                return AppStates.newProFormaDocument;
 
            case PurchaseDocumentKind.Expense:
                return AppStates.newPurchaseExpense;
 
            case PurchaseDocumentKind.PurchaseInvoice:
                return AppStates.newPurchaseInvoice;
 
            case PurchaseDocumentKind.PurchaseInvoiceAdjustment:
                return AppStates.newPurchaseInvoiceAdjustment;
 
            case InventoryDocumentKind.GoodsIssue:
            case InventoryDocumentKind.InternalGoodsIssue:
                return AppStates.inventoryGoodsIssueNew;
 
            case InventoryDocumentKind.GoodsReceipt:
            case InventoryDocumentKind.InternalGoodsReceipt:
                return AppStates.inventoryGoodsReceiptNew;
 
            case InventoryDocumentKind.GoodsIssueAdjustment:
                return AppStates.inventoryGoodsIssueAdjustmentNew;
            case InventoryDocumentKind.GoodsReceiptAdjustment:
                return AppStates.inventoryGoodsReceiptAdjustmentNew;
 
            case InventoryDocumentKind.Stocktaking:
                return AppStates.inventoryStocktakingNew;
        }
        throw new Error(`Unsupported document kind: ${kind}`);
    }
}
